export const GET_POOLS = 'GET_POOLS'
export const GET_POOLS_SUCCESS = 'GET_POOLS_SUCCESS'
export const GET_POOLS_ERROR = 'GET_POOLS_ERROR'
export const GET_POOL = 'GET_POOL'
export const GET_POOL_SUCCESS = 'GET_POOL_SUCCESS'
export const GET_POOL_ERROR = 'GET_POOL_ERROR'
export const GET_POSTULANTES = 'GET_POSTULANTES'
export const GET_POSTULANTES_SUCCESS = 'GET_POSTULANTES_SUCCESS'
export const GET_POSTULANTES_ERROR = 'GET_POSTULANTES_ERROR'
export const CLEAR_DATA = 'CLEAR_DATA'
export interface Postulante {
  id: number
  nombre: string
  localidad: string
}
interface Pagination {
  pageSize?: number
  totalPages: number
  currentPage: number
  totalItems?: number
  totalItemsInPage?: number
}
export interface TalentPoolProfilesList {
  pagination: Pagination
  profiles: Postulante[]
}
export interface Pool {
  id: number
  titulo: string
  cantidad: number
  adquirido: boolean
  fotoURL: string
  postulantes: Postulante[]
}
export interface PoolsState {
  pools: Pool[] | null
  postulantes: Postulante[]
  pagination: Pagination | null
  activePool: Pool | null
  loading: boolean
  error: boolean
}
export const initialState: PoolsState = {
  pools: null,
  postulantes: [],
  pagination: null,
  activePool: null,
  loading: true,
  error: false,
}
export interface GetPools {
  type: typeof GET_POOLS
  payload: null
}
export interface GetPoolsSuccess {
  type: typeof GET_POOLS_SUCCESS
  payload: Pool[]
}
export interface GetPoolsError {
  type: typeof GET_POOLS_ERROR
  payload: boolean
}
export interface GetPool {
  type: typeof GET_POOL
  payload: null
}
export interface GetPoolSuccess {
  type: typeof GET_POOL_SUCCESS
  payload: Pool
}
export interface GetPoolError {
  type: typeof GET_POOL_ERROR
  payload: null
}
export interface GetPostulantes {
  type: typeof GET_POSTULANTES
  payload: null
}
export interface GetPostulantesSuccess {
  type: typeof GET_POSTULANTES_SUCCESS
  payload: TalentPoolProfilesList
}
export interface GetPostulantesError {
  type: typeof GET_POSTULANTES_ERROR
  payload: boolean
}

export interface ClearData {
  type: typeof CLEAR_DATA
  payload: PoolsState
}

export type PoolsActions =
  | GetPools
  | GetPoolsSuccess
  | GetPoolsError
  | GetPool
  | GetPoolSuccess
  | GetPoolError
  | GetPostulantes
  | GetPostulantesSuccess
  | GetPostulantesError
  | ClearData
